import React from "react";
import Loader from "../Loader";
import PageHeader from "../PageHeader";
import PostItem from "../PostItem";
import { Select, Pagination } from "antd";
import { RichText } from "prismic-reactjs";
import { connect } from "react-redux";
import {
  fetchTags,
  fetchTagsNextPage,
  fetchResources,
  fetchResourcesWithTags,
  fetchResourcePage,
} from "../../store/actions";
import { linkResolver } from "../../prismic-configuration";

export class Resources extends React.Component {
  state = {
    selectedFilters: null,
  };

  componentDidMount() {
    this.props.fetchResourcePage();
    this.props.fetchResources();
    this.props.fetchTags();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.tagState.next_page !== this.props.tagState.next_page) {
      if (this.props.tagState.page + 1 <= this.props.tagState.total_pages)
        this.props.fetchTagsNextPage({
          page: this.props.tagState.page + 1,
        });
    }
  }

  applyFilter = (type) => (value) => {
    this.setState(
      {
        selectedFilters: {
          ...this.state.selectedFilters,
          [type]: value,
        },
      },
      () => {
        const values = Object.values(this.state.selectedFilters);
        const arr = values.filter((v) => v !== undefined);
        this.props.fetchResourcesWithTags({}, arr);
      }
    );
  };

  renderFilters = () => {
    const { tagState } = this.props;

    if (!tagState.settled) {
      return;
    }

    return (
      <div className='row mb-4'>
        <div className='col-4'>
          <Select
            placeholder='Type'
            allowClear
            onChange={this.applyFilter("docType")}
            style={{ width: "100%" }}
          >
            {this.props.tagState.results.map((item) => {
              if (item.data.type === "Type") {
                return (
                  <Select.Option key={item.id} value={item.data.name[0].text}>
                    {item.data.name[0].text}
                  </Select.Option>
                );
              }

              return null;
            })}
          </Select>
        </div>

        <div className='col-4'>
          <Select
            placeholder='Thematic Area'
            allowClear
            onChange={this.applyFilter("thematicArea")}
            style={{ width: "100%" }}
          >
            {this.props.tagState.results.map((item) => {
              if (item.data.type === "Focus Area") {
                return (
                  <Select.Option key={item.id} value={item.data.name[0].text}>
                    {item.data.name[0].text}
                  </Select.Option>
                );
              }

              return null;
            })}
          </Select>
        </div>

        <div className='col-4'>
          <Select
            placeholder='Country'
            allowClear
            onChange={this.applyFilter("country")}
            style={{ width: "100%" }}
          >
            {this.props.tagState.results.map((item) => {
              if (item.data.type === "Country") {
                return (
                  <Select.Option key={item.id} value={item.data.name[0].text}>
                    {item.data.name[0].text}
                  </Select.Option>
                );
              }

              return null;
            })}
          </Select>
        </div>
      </div>
    );
  };

  onPageChange = (page) => {
    if (this.state.selectedFilters) {
      const values = Object.values(this.state.selectedFilters);
      const arr = values.filter((v) => v !== undefined);
      this.props.fetchResourcesWithTags({ page: page }, arr);
    } else {
      this.props.fetchResources({ page: page });
    }
  };

  renderItems = () => {
    const { resourceState } = this.props;

    if (!resourceState.settled) {
      return <Loader />;
    } else {
      if (resourceState.results.length > 0) {
        return (
          <React.Fragment>
            {resourceState.results.map((result) => {
              return (
                <PostItem
                  key={result.id}
                  prismicCtx={this.props.prismicCtx}
                  item={result}
                />
              );
            })}

            <Pagination
              pageSize={resourceState.results_per_page}
              total={resourceState.total_results_size}
              onChange={this.onPageChange}
            />
          </React.Fragment>
        );
      } else {
        return <p>No results found.</p>;
      }
    }
  };


  render() {
    const { resourcePageState } = this.props;
    if (resourcePageState.settled) {
      return (
        <React.Fragment>
          <PageHeader title={RichText.asText(resourcePageState.entity.data.title)} />
          <div className='container pt-5 pb-5'>
            <div className='row'>
              <div className='col-12 col-md-4 col-lg-5 order-md-last mb-4 mb-md-0 main-image'>
                {resourcePageState.entity.data.main_image.url && (
                  <div className="banner text-center">
                    <a href={resourcePageState.entity.data.main_image_url.url} target="_blank">
                      <img
                        src={resourcePageState.entity.data.main_image.url}
                        className="img-fluid"
                        alt="banner"
                      />
                    </a>
                  </div>
                )}
                
              </div>
              <div className='col-12 col-md-8 col-lg-7'>
                {RichText.render(resourcePageState.entity.data.text, linkResolver)}
                {this.renderFilters()}
                {this.renderItems()}
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    } else {
      return <Loader />
    }
  }
}

const mapStateToProps = (state) => ({
  resourceState: state.resource,
  tagState: state.tag,
  resourcePageState: state.resourcePage,
});

export default connect(mapStateToProps, {
  fetchTags,
  fetchTagsNextPage,
  fetchResources,
  fetchResourcesWithTags,
  fetchResourcePage,
})(Resources);



// WEBPACK FOOTER //
// ./src/components/pages/Resources.js